import React, { useState, useEffect, Fragment } from 'react';

import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import sweetAlertStyles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import Button from 'components/CustomButtons/Button';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react';
import Card from 'components/Card/Card';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import { Assignment } from '@material-ui/icons';
import CardIcon from 'components/Card/CardIcon';
import { makeStyles, Paper, TextField, FormControlLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';

import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy, wsUpdate, wsRemove } from 'services/WService';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SweetAlert from 'react-bootstrap-sweetalert';
import { currency, nPercent } from 'hooks/Pipe';
import ModalPricesUpdate from './Modal/ModalPricesUpdate';
import { useModal } from 'hooks/useModal';

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...sweetAlertStyles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  marginRight: {
    float: 'right',
    margin: 'auto',
  },
  title: {
    marginTop: '15px',
    fontSize: '20px',
    color: '#3C4858',
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: '20px',
    '& h6': {
      fontSize: 13,
      color: theme.palette.text.secondary,
    },
    '& h5': {
      fontSize: 15,
      fontWeight: 400,
    },
    marginBottom: '15px',
    height: '90%',
  },
  titleCheckBox:{
    marginTop: '5px',
    color: '#b1b1b1 !important',
  },
}));

export default WithApp(function Header(props) {
  const classes = useStyles();

  const { buyDetail, showNotify } = props;

  const [model, setOpen] = useModal();
  const [warehouses, setWarehouses] = useState([]);
  const [paymentTs, setPaymentTs] = useState([]);
  const [purchOrder, setPurchOrder] = useState([]);
  const [checkPurchOrder, setCheckPurchOrder] = useState(true);
  const [alert, setAlert] = useState();

  async function listWarehouse() {
    let response = await wsFindBy('logi/warehouse', { warehouse_type: 'N' });
    if (response.success) setWarehouses(response.data);
  }

  async function listPaymentTs() {
    let response = await wsGetAll('base/payment-term');
    if (response.success) setPaymentTs(response.data);
  }
  async function listPurchOrders() {
    let state = ['S','R'];
    let response = await wsFindBy('purch/purchase-order', {state, base_business_partner_id: buyDetail.base_business_partner_id, logi_warehouse_id: buyDetail.logi_warehouse_id});
    if (response.success) setPurchOrder(response.data);
  }

  async function updateHeader(buyData) {
    let response = await wsUpdate('purch/purchase', buyDetail.id, buyData);
    if (response.success) {
      showNotify(response.message);
      props.reload();
    } else {
      showNotify(response.message, 'error');
    }
  }
  async function updatePurchOrder(buyData) {
    let response = await wsUpdate(`purch/purchase/${buyDetail.id}/update-purch-order`, buyData);
    if (response.success) {
      showNotify(response.message);
      props.reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  function confirmDelete() {
    setAlert(
      <SweetAlert
        warning
        showCancel
        title="¿Está seguro de eliminar?"
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        onConfirm={() => {
          deletePurchase();
          setAlert(undefined);
        }}
        onCancel={() => setAlert(undefined)}
      />,
    );
  }

  async function deletePurchase() {
    let response = await wsRemove('purch/purchase', buyDetail.id);
    if (response.success) {
      window.location.href = `/admin/compras/operaciones/importaciones?eliminado=${response.message}`;
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function validate(force = 'N') {
    let response = await wsUpdate(`purch/purchase/${buyDetail.id}/change-state`, {
      proc_status: 'V',
      force,
    });
    if (response.success) {
      showNotify(response.message);
      props.reload();
    } else {
      if (
        response.data?.prices !== undefined &&
        response.data?.products !== undefined &&
        response.data?.price_lists !== undefined
      ) {
        setOpen({
          open: true,
          prices: response.data.prices,
          products: response.data.products,
          priceLists: response.data.price_lists,
        });
      } else {
        showNotify(response.message, 'error');
      }
    }
  }

  async function updateState(state) {
    let response = await wsUpdate(`purch/purchase/${buyDetail.id}/change-state`, {
      proc_status: state,
      checkPurchOrder: checkPurchOrder ? 1 : 0,
    });
    if (response.success) {
      showNotify(response.message);
      props.reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listWarehouse();
    listPaymentTs();
    return () => {
      setWarehouses([]);
      setPaymentTs([]);
    };
  }, []);

  useEffect(() => {
    if(buyDetail.id && buyDetail.proc_status == 'V'){
      listPurchOrders();
      return () => {
        setPurchOrder([]);
      };
    }
  }, [buyDetail]);


  return (
    <Fragment>
      {alert}
      <ModalPricesUpdate
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        purchaseId={buyDetail.id}
        reload={props.reload}
        setAlert={setAlert}
        classes={classes}
        purchase={buyDetail}
      />
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <div className={classes.title}>
            <span>Información general</span>
            <Button
              color={props.themeContext.buttonColorDanger}
              className={classes.marginRight}
              disabled={buyDetail.proc_status != 'D'}
              onClick={confirmDelete}
              size="sm"
              style={{ marginLeft: '10px' }}
            >
              Eliminar
            </Button>

            {buyDetail.proc_status === 'V' ? (
              <Button
                color={props.themeContext.buttonColorWarning}
                className={classes.marginRight}
                onClick={() => updateState('D')}
                size="sm"
                style={{ marginLeft: '10px' }}
              >
                Revertir
              </Button>
            ) : undefined}

            {buyDetail.proc_status == 'D' ? (
              <Button
                color={props.themeContext.buttonColorSuccess}
                className={classes.marginRight}
                onClick={() => validate()}
                size="sm"
              >
                Validar
              </Button>
            ) : (
              <Button
                color={props.themeContext.buttonColorSuccess}
                className={classes.marginRight}
                onClick={() => updateState('C')}
                disabled={buyDetail.proc_status != 'V'}
                size="sm"
              >
                {buyDetail.proc_status != 'V' ? 'Confirmado' : 'Confirmar'}
              </Button>
            )}
          </div>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xl={3} lg={4} sm={4} xs={12} mb="3px">
              <Paper className={classes.paper}>
                {buyDetail.proc_status == 'D' ? (
                  <Autocomplete
                    key={warehouses}
                    options={warehouses}
                    getOptionLabel={(option) => option.WhsName}
                    defaultValue={
                      !!buyDetail
                        ? warehouses.find((item) => item.id == buyDetail.logi_warehouse_id)
                        : undefined
                    }
                    renderInput={(params) => <TextField {...params} label="Almacén" />}
                    onChange={(e, item) => {
                      if (!!item) {
                        updateHeader({ logi_warehouse_id: item.id });
                      }
                    }}
                  />
                ) : (
                  <>
                    <h6>Almacén</h6>
                    <h5>{buyDetail.WhsName}</h5>
                  </>
                )}

                <h6>Fec. comprobante</h6>
                <h5>{buyDetail.tax_date ? moment(buyDetail.tax_date).format('DD-MM-YYYY') : ''}</h5>
                <h6>Códido proveedor</h6>
                <h5>{buyDetail.CardCode}</h5>
                <h6>Proveedor</h6>
                <h5>{buyDetail.CardName}</h5>
                <h6>Ruc / Dni</h6>
                <h5>{buyDetail.LicTradNum}</h5>
                <h6>Factura / Boleta</h6>
                <h5>{buyDetail.document_type_description}</h5>
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Serie sunat</h6>
                <h5>{buyDetail.ReceiptSerie}</h5>
                <h6>Número sunat</h6>
                <h5>{buyDetail.ReceiptNumber}</h5>
                {/* <h6>taxidnum</h6>
              <h5>{buyDetail.}</h5> */}
                <h6>Operación gravada</h6>
                <h5>{currency(buyDetail.op_gravada)}</h5>
                <h6>Operación inafecta</h6>
                <h5>{currency(buyDetail.op_inafecta)}</h5>
                <h6>Operación exonerada</h6>
                <h5>{currency(buyDetail.op_exonerada)}</h5>
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Igv en monto</h6>
                <h5>{currency(buyDetail.VatSum)}</h5>
                <h6>Impuesto. selec. al consumo</h6>
                <h5>{currency(buyDetail.SumIsc)}</h5>
                <h6>Otros tributos</h6>
                <h5>{currency(buyDetail.SumOtTrib)}</h5>
                <h6>Otros cargos</h6>
                <h5>{currency(buyDetail.SumOtCarg)}</h5>
                <h6>Descuento</h6>
                <h5>{currency(buyDetail.total_discount)}</h5>
                <h6>Total de impuestos</h6>
                <h5>{currency(buyDetail.VatSumTotal)}</h5>
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Total del doc.</h6>
                <h5>{currency(buyDetail.DocTotal)}</h5>
                <h6>Moneda</h6>
                <h5>{buyDetail.Currency}</h5>
                <h6>Tipo de guía</h6>
                <h5>{buyDetail.tipo_guia}</h5>
                <h6>Serie guía</h6>
                <h5>{buyDetail.serie_guia}</h5>
                <h6>Número guía</h6>
                <h5>{buyDetail.numero_guia}</h5>
                <h6>Otros tipos de doc.</h6>
                <h5>{buyDetail.tipo_doc_otro}</h5>
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Serie de otro tipo doc.</h6>
                <h5>{buyDetail.serie_otro}</h5>
                <h6>Nume de otro tipo doc.</h6>
                <h5>{buyDetail.numero_otro}</h5>
                <h6>Leyenda</h6>
                <h5>{buyDetail.leyenda}</h5>
                <h6>Mensaje de error</h6>
                <h5>{buyDetail.error_message}</h5>
                {buyDetail.proc_status == 'D' ? (
                  <TextField
                    label="Fec. vencimiento"
                    type="date"
                    value={moment(buyDetail.DocDueDate).format('YYYY-MM-DD') || ''}
                    onChange={(e) => updateHeader({ DocDueDate: e.target.value })}
                    inputProps={{
                      min: moment(buyDetail.tax_date).format('YYYY-MM-DD'),
                    }}
                    fullWidth
                    size="small"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                ) : (
                  <>
                    <h6>Fec. vencimiento</h6>
                    <h5>
                      {buyDetail.DocDueDate
                        ? moment(buyDetail.DocDueDate).format('YYYY-MM-DD')
                        : ''}
                    </h5>
                  </>
                )}

                {buyDetail.proc_status == 'D' ? (
                  <Autocomplete
                    key={paymentTs}
                    options={paymentTs}
                    getOptionLabel={(option) => option.PymntGroup}
                    defaultValue={
                      !!buyDetail
                        ? paymentTs.find((item) => item.id == buyDetail.base_payment_term_id)
                        : undefined
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Término de pago" margin="normal" />
                    )}
                    onChange={(e, item) => {
                      if (!!item) {
                        updateHeader({ base_payment_term_id: item.id });
                      }
                    }}
                  />
                ) : (
                  <div>
                    <h6>Término de pago</h6>
                    <h5>{buyDetail.PymntGroup}</h5>
                  </div>
                )}
                {buyDetail.proc_status == 'V' ? (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkPurchOrder}
                          onChange={(e) => setCheckPurchOrder(e.target.checked)}
                        />
                      }
                      label="Selección de orden de compra"
                      classes={{ label: classes.titleCheckBox }}
                    />
                  {checkPurchOrder == true ? (
                    <Autocomplete
                      key={purchOrder}
                      options={purchOrder}
                      getOptionLabel={(option) => `${option.id} - ${option.CardName} - ${option.WhsName}`}
                      defaultValue={
                        !!buyDetail
                          ? purchOrder.find((item) => item.id == buyDetail.purch_order_id)
                          : undefined
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Orden de compra" margin="normal" />
                      )}
                      onChange={(e, item) => {
                        if (!!item) {
                          updatePurchOrder({ purch_order_id: item.id });
                        }
                      }}
                    />
                  ) : undefined}
                  </>
                ) : undefined}
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>% descuento</h6>
                <h5>{nPercent(buyDetail.DiscPrcnt)}</h5>
                <h6>Descuento en monto</h6>
                <h5>{currency(buyDetail.DiscSum)}</h5>
                {/* <h6>Código de almacén</h6>
                <h5>{buyDetail.WhsCode}</h5> */}
                <h6>Dirección</h6>
                <h5>{buyDetail.Address}</h5>
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Nombre de archivo</h6>
                <h5>{buyDetail.filename}</h5>
                <h6>Días de crédito</h6>
                <h5>{buyDetail.ExtraDays}</h5>
                <h6>Estado de proceso</h6>
                <h5>
                  {buyDetail.proc_status == 'D'
                    ? 'Borrador'
                    : buyDetail.proc_status == 'V'
                    ? 'Validado'
                    : buyDetail.proc_status == 'C'
                    ? 'Confirmado'
                    : buyDetail.proc_status == 'X'
                    ? 'En espera'
                    : buyDetail.proc_status == 'R'
                    ? 'Recibido'
                    : buyDetail.proc_status == 'A'
                    ? 'Anulado'
                    : buyDetail.proc_status == 'Y'
                    ? 'Preparado'
                    : buyDetail.proc_status == 'T'
                    ? 'Contabilizado'
                    : buyDetail.proc_status == 'Z'
                    ? 'Para NC - compra'
                    : 'NC registrada'}
                </h5>
                <h6>Estado del documento</h6>
                <h5>{buyDetail.doc_status == 'O' ? 'Abierto' : 'Cerrado'}</h5>
                <h6>Cancelado</h6>
                <h5>{buyDetail.cancelled == 'Y' ? 'Si' : 'No'}</h5>
                {/* <h6>certificatechecksum</h6>
              <h5>{buyDetail.}</h5> */}
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Suma de transferencia gratuita</h6>
                <h5>{currency(buyDetail.sum_free_transfer)}</h5>
                <h6>Suma de bonificaciones</h6>
                <h5>{currency(buyDetail.sum_bonification)}</h5>
                <h6>Suma de Igv</h6>
                <h5>{currency(buyDetail.sum_igv)}</h5>
                <h6>Fecha de creación</h6>
                <h5>
                  {buyDetail.created_at ? moment(buyDetail.created_at).format('YYYY-MM-DD') : ''}
                </h5>
                <h6>fecha de actualización</h6>
                <h5>
                  {buyDetail.updated_at ? moment(buyDetail.updated_at).format('YYYY-MM-DD') : ''}
                </h5>
                <h6>ID objeto Sap</h6>
                <h5>{buyDetail.ObjType}</h5>
              </Paper>
            </GridItem>
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Fecha de contabilización</h6>
                <h5>{buyDetail.DocDate ? moment(buyDetail.DocDate).format('YYYY-MM-DD') : ''}</h5>
                <h6>Última fecha de proceso</h6>
                <h5>
                  {buyDetail.last_process_date
                    ? moment(buyDetail.last_process_date).format('YYYY-MM-DD')
                    : ''}
                </h5>
                <h6>Docentry de factura de sap</h6>
                <h5>{buyDetail.invoice_id}</h5>
                <h6>Docentry de recep. de merca.</h6>
                <h5>{buyDetail.receipt_id}</h5>
                <h6>Fecha de recepción</h6>
                <h5>
                  {buyDetail.reception_date
                    ? moment(buyDetail.reception_date).format('YYYY-MM-DD')
                    : ''}
                </h5>
                <h6>Versión ubl del archivo xml</h6>
                <h5>{buyDetail.ubl_version}</h5>
              </Paper>
            </GridItem>
            {buyDetail.purch_order_id == null ? undefined: (
            <GridItem xl={3} lg={4} sm={4} xs={12}>
              <Paper className={classes.paper}>
                <h6>Fecha de orden de compra</h6>
                <h5>{buyDetail.reception_date
                    ? moment(buyDetail.order_created_at).format('YYYY-MM-DD')
                    : '' || ''}</h5>
                <h6>Código de proveedor de orden de compra</h6>
                <h5>{buyDetail.order_CardCode || ''}</h5>
                <h6>Razón social de proveedor de orden de compra</h6>
                <h5>{buyDetail.order_CardName || ''}</h5>
                <h6>Almacén de orden de compra</h6>
                <h5>{buyDetail.order_WhsName || ''}</h5>
              </Paper>
            </GridItem>
            )}
          </GridContainer>
        </CardBody>
      </Card>
    </Fragment>
  );
});
